module.exports = __webpack_public_path__ + "img/wolf_1.8303d41b.jpg";